import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as selectors from './selectors'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    userPermissions: selectors.userPermissions(state),
    userRoles: selectors.userRoles(state),
  })

  Enhancer.displayName = 'PermissionsEnhancer'

  Enhancer.propTypes = {
    userPermissions: PropTypes.array.isRequired,
    userRoles: PropTypes.array.isRequired,
  }

  return connect(mapStateToProps)(Enhancer)
}
